import React from 'react';
import { CardHeader, Avatar, Tooltip, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import InfoTooltipIcon from '../icons/InfoTooltipIcon';

/**
 * Reusable CardHeader component with icon and tooltip.
 *
 * Props:
 * - icon: React node (e.g., <SpeedRoundedIcon />)
 * - tooltip: string (tooltip text shown on hover)
 * - iconColor: string (default: '#96b100')
 * - iconBgColor: string (default: '#c2dd00')
 * - title: string or node (optional CardHeader title)
 * - subheader: string or node (optional CardHeader subheader)
 * - actionIcon: React node (optional custom action icon instead of default InfoRoundedIcon)
 */
const CardHeaderWithIcon = ({
  icon,
  tooltip,
  iconColor = '#96b100',
  iconBgColor = '#c2dd00',
  title,
  subheader,
  actionIcon,
  dimmed = false,
  children,
}) => {
  return (
    <>
      <CardHeader
        sx={{
          p: 0,
          opacity: dimmed ? 0.2 : 1,
          transition: 'opacity 0.3s ease-in-out',
          display: 'flex',
          mb: 1,
        }}
        title={title}
        titleTypographyProps={{
          variant: 'subtitle1',
          fontWeight: 600,
          // color: 'textSecondary',
        }}
        avatar={
          <Avatar
            variant="rounded"
            sx={{
              bgcolor: (theme) => alpha(iconBgColor, 0.1),
              borderRadius: 3,
            }}
          >
            {icon &&
              React.cloneElement(icon, {
                sx: { verticalAlign: 'middle', color: iconColor },
              })}
          </Avatar>
        }
        subheader={subheader}
        action={
          tooltip && (
            <InfoTooltipIcon title={tooltip} placement="top" arrow>
              {actionIcon || (
                <InfoRoundedIcon
                  sx={{
                    color: (theme) =>
                      theme.palette.mode === 'light' ? 'lightgray' : 'gray',
                    ml: 1,
                  }}
                  fontSize="small"
                />
              )}
            </InfoTooltipIcon>
          )
        }
      />
      {children}
    </>
  );
};

export default CardHeaderWithIcon;
